<style lang="scss" scoped>
.sync {
  float: right;
  background: #17cfb8;
  border-color: #17cfb8;
}
</style>

<template>
  <div>
    <div class="clearfix mb20">
      <tab :arr="arr"></tab>
      <el-button
        type="primary"
        class="sync"
        v-if="type == `/third/${id}/channel/edit`"
        @click="asyncmaterial"
      >
        <i class="el-icon-sort"></i>微信端素材同步
      </el-button>
    </div>
    <router-view ref="child"></router-view>
  </div>
</template>

<script>
import tab from '@/components/tab';
export default {
  components: {
    tab,
  },
  props: ['id'],
  computed: {},
  data() {
    return {
      type: this.$route.path
        .split('/')
        .slice(0, 5)
        .join('/'),
      arr: [
        {
          name: '生成渠道二维码',
          url: `/third/${this.id}/channel/create`,
        },
        {
          name: '编辑渠道二维码',
          url: `/third/${this.id}/channel/edit`,
        },
        {
          name: '渠道二维码数据查询',
          url: `/third/${this.id}/channel/refer`,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    async asyncmaterial() {
      let res = await this.$http.get(`/api/${this.id}/material/async`);
      if (res) {
        await this.$refs.child.getData();
        this.$message.success('同步成功');
      }
    },
  },
};
</script>
